"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2667],{

/***/ 92667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81663);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92734);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35316);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7490);
/* harmony import */ var _mui_material_Alert__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24854);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19599);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8072);
/* harmony import */ var redux_settings_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57710);
/* harmony import */ var redux_settings_reducer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66126);









function TransitionUp(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        direction: "bottom"
    }));
}
var Alert = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Alert(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Alert__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        elevation: 1,
        ref: ref,
        variant: "filled",
        style: {
            width: true
        }
    }, props));
});
var CustomSnackbar = function(props) {
    var snackbar = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_settings_reducer__WEBPACK_IMPORTED_MODULE_4__/* .getSettingsSnackbar */ .IS);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var handleClose = function() {
        dispatch((0,redux_settings_action__WEBPACK_IMPORTED_MODULE_3__/* .snackbarAction */ .ig)({
            autoHideDuration: (snackbar === null || snackbar === void 0 ? void 0 : snackbar.autoHideDuration) || 3000,
            message: (snackbar === null || snackbar === void 0 ? void 0 : snackbar.message) || "",
            severity: (snackbar === null || snackbar === void 0 ? void 0 : snackbar.severity) || "info",
            open: false
        }));
    };
    var handleSnackClose = function(_ev, reason) {
        if (reason === "clickaway") {
            return;
        }
        handleClose();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        open: snackbar === null || snackbar === void 0 ? void 0 : snackbar.open,
        autoHideDuration: snackbar === null || snackbar === void 0 ? void 0 : snackbar.autoHideDuration,
        onClose: handleSnackClose,
        TransitionComponent: TransitionUp,
        anchorOrigin: {
            vertical: "top",
            horizontal: "center"
        }
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Alert, {
            sx: {
                width: "100%"
            },
            onClose: handleClose,
            severity: snackbar === null || snackbar === void 0 ? void 0 : snackbar.severity,
            children: snackbar === null || snackbar === void 0 ? void 0 : snackbar.message
        })
    }), TransitionUp ? TransitionUp.name : "");
};
/* harmony default export */ __webpack_exports__["default"] = (CustomSnackbar);


/***/ })

}]);